<template>
  <!-- Screenshots Section Start -->
  <section id="our-app" class="screenshot padding-top-bottom">
    <div class="screenshot-decor">
      <!-- <div class="screenshot-circle1">
        <img
          :src='"../assets/images/feature-circle-two.png"'
          alt="feature-circle-two"
        />
      </div> -->
      <div class="screenshot-circle2">
        <img
          class="circle-3"
          :src='"../assets/images/circle-3.png"'
          alt="feature-circle"
        />
      </div>
      <div class="screenshot-circle3 d-none d-lg-block">
        <img
          style="max-width: 300px; max-height: 300px"
          :src='"../assets/images/circle-3.png"'
          alt="feature-circle-three"
        />
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="screenshot-contain">
            <img
              class="mobile-light-left"
              :src='"../assets/images/light.png"'
              alt="light"
            />
            <img
              class="mob-mocup img-fluid"
              :src='"../assets/images/screenshot-mob.png"'
              alt="screenshot-mob"
            />
            <img
              class="mobile-light-right"
              :src='"../assets/images/light-right.png"'
              alt="light-right"
            />
             <swiper ref="mySwiper" :options="swiperOptions" :class="'swiper screenshot-carousel'">
               <!-- can't loop? -->
                <swiper-slide v-for="num in 12" :key="num">
                  <div class="screenshot-item">
                    <img :src='getImage(num - 1)' class="img-fluid" alt="app" />
                  </div>  
                </swiper-slide>
             </swiper>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Screenshots Section End -->
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper.min.css";

export default {
  name: "Screenshot",
  components: {  Swiper,
    SwiperSlide },
   directives: {
    swiper: directive
  },
  data() {
    return {

      swiperOptions: {
       slidesPerView: 5,
       loop: true,
       spaceBetween: 30,
       centeredSlides: true,
       breakpoints: {
          0: { slidesPerView: 2},
          767: { slidesPerView: 2},
          768: { slidesPerView: 3},
          992: { slidesPerView: 4},
          // 1200: { slidesPerView: 5},
       }
      },
    };
  },
  methods: {
    getImage(index) {
      return require(`../assets/images/screenshot/${index}.png`);
    }
  },
};
</script>

<style lang="sass">
  .screenshot-item > img
    height: 455px
    width: 100%

    @media (max-width: 767px) 
      height: 350px
</style>


// WEBPACK FOOTER //
// src/components/screenshots.vue